import type { ConsultantIndiaValues } from "../consultant-india/consultant-india.schema.ts";
import type { ConsultantUsValues } from "../consultant-us/consultant-us.config.ts";
import type { AgencyConsultantValues } from "../consultant-agency-us/consultant-agency-us.config.ts";
import type { AgencyRegistrationValues } from "../../../../pages/onboarding/agency-registration/agency-registration.config.ts";
import { businessType, cityStateZip, optional, paymentMethod, paymentTerms } from "./submission-api.ts";

export function mapIndiaConsultant(v: ConsultantIndiaValues) {
  return {
    firstName: v.firstName.trim(),
    lastName: v.lastName.trim(),
    phone: v.contactNumber.trim(),
    alternatePhone: optional(v.alternateContactNumber),
    businessAddress: v.correspondenceAddress.trim(),
    taxId: v.pan.trim(),
    beneficiaryName: v.accountName.trim(),
    accountNumber: v.accountNumber.trim(),
    bankName: v.bankName.trim(),
    branchName: optional(v.branchName),
    ifscCode: v.ifscCode.trim(),
    consultantType: "INDIAN_CONSULTANT",
  };
}
export function mapUsConsultant(v: ConsultantUsValues) {
  return {
    firstName: v.firstName.trim(), lastName: v.lastName.trim(), preferredName: optional(v.preferredName), personalEmail: optional(v.personalEmail), phone: v.phoneNumber.trim(),
    businessDbaName: optional(v.businessName), businessAddress: v.businessAddress.trim(), cityStateZip: cityStateZip(v), country: optional(v.country), businessType: businessType(v.businessType), taxId: v.taxId.trim(), stateOfFormation: optional(v.stateOfFormation),
    beneficiaryName: v.accountName.trim(), accountNumber: v.accountNumber.trim(), bankName: v.bankName.trim(), routingNumber: v.routingNumber.trim(), swiftCode: optional(v.swiftCode), paymentMethod: paymentMethod(v.paymentMethod), remittanceEmail: optional(v.remittanceEmail), paymentTerms: paymentTerms(v.paymentTerms),
  };
}

export function mapVendorConsultant(v: AgencyConsultantValues) {
  return { firstName: v.firstName.trim(), lastName: v.lastName.trim(), preferredName: optional(v.preferredName), personalEmail: v.email.trim(), phone: v.phone.trim(), clientProject: v.clientProject.trim(), caeliusProjectContact: v.primaryContact.trim() };
}

export function mapAgency(v: AgencyRegistrationValues) {
  return {
    legalCompanyName: v.legalCompanyName.trim(), dbaName: optional(v.dba), primaryContactName: v.primaryContact.trim(), contactTitle: optional(v.title), email: optional(v.email), phone: v.phone.trim(),
    businessAddress: optional(v.businessAddress), cityStateZip: cityStateZip(v), country: optional(v.country), businessType: businessType(v.businessType), taxId: v.ein.trim(), stateOfFormation: optional(v.formationState), apRemittanceEmail: optional(v.remittanceEmail),
    accountNumber: v.accountNumber.trim(), bankName: v.bankName.trim(), routingNumber: v.routingNumber.trim(), swiftCode: optional(v.swiftCode), paymentMethod: paymentMethod(v.paymentMethod), remittanceEmail: optional(v.remittanceEmail), paymentTerms: paymentTerms(v.paymentTerms),
  };
}
